//TODO: DisplayContent for PromotionDetails
//TODO: ErrorBoundaries for PromotionDetails

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getCMSObject, PromotionDetails, BoxedContent, DisplayContent } from 'sg-ui-components';
// import PromotionDetails from '../Components/PromotionDetails';
import LongPlayCollections from '../Components/LongPlayCollections';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import { jurisdiction } from '../promotionConfig';

const PromotionDetailsPage = ({ user, config, cmsSourceFirebase, actions, match, promotion }) => {
    const telescriptPromotionDetails = getCMSObject('data.components.teleScripts.promotionDetails.jsonBlock');
    const [promotionName, setPromotionName] = useState('Promotion Details');

    return (
        <Layout
            {...{
                user,
                config,
                cmsSourceFirebase,
                actions,
                match,
                configReplacements: [
                    {
                        find: '{{PROMOTION_NAME}}',
                        replace: promotionName ?? '',
                    },
                ],
            }}>
            <PromotionDetails
                user={user}
                config={config}
                promotion={promotion}
                actions={actions}
                jurisdiction={jurisdiction}
                telescript={telescriptPromotionDetails}
                setPageTitle={setPromotionName}
            />

            <DisplayContent isVisible={promotionName == 'Lucky Letters'} note='Long Play Game'>
                <div className='mt-3'></div>

                <BoxedContent note='Collections' hash='collections' isActive={true} isVisible={true} title={'Collections'}>
                    <LongPlayCollections />
                </BoxedContent>

                <BoxedContent note='How to Play section' hash='howtoplay' isActive={true} isVisible={true} title={'How to Play'}>
                    <div>
                        <p>
                            It’s easy to collect <strong>Lucky Letters</strong> and turn your Scratchers tickets into exclusive rewards! Just follow these
                            simple steps to start building your collections:
                        </p>
                        <ul>
                            <li>
                                <strong>Buy:</strong> Purchase any $5 <strong>&quot;Living Lucky with Luke Combs&quot;</strong> Scratchers ticket (Game 431).
                            </li>
                            <li>
                                <strong>Scan or Enter:</strong> Log in to your My Lottery® Players Club account via the official mobile app or at MOLottery.com.
                                Scan the ticket barcode or manually enter the ticket number.
                            </li>
                            <li>
                                <strong>Collect Letters:</strong> For every eligible ticket you enter, you will randomly receive letters to fill your{' '}
                                <strong>Lucky Collection</strong> or <strong>Bonus Collection</strong> grids.
                            </li>
                            <li>
                                <strong>Win Rewards:</strong> Complete a word collection to automatically unlock your prize!
                            </li>
                        </ul>
                        <h3 id='collection-prizes'>Collection Prizes</h3>
                        <table>
                            <thead>
                                <tr>
                                    <th>Collection</th>
                                    <th>Letters Needed</th>
                                    <th>Reward</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>Lucky Collection</strong>
                                    </td>
                                    <td>L • U • C • K • Y</td>
                                    <td>
                                        <strong>200 Draw Points</strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>Bonus Collection</strong>
                                    </td>
                                    <td>B • O • N • U • S</td>
                                    <td>
                                        <strong>$2-Off Draw Games Coupon</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <blockquote>
                            <p>
                                <strong>Note:</strong> Every $5 ticket entered also automatically earns you one entry into the grand prize drawing for the{' '}
                                <strong>Luke Combs VIP Concert Experience for Two</strong> in Nashville and a chance to win <strong>$500,000</strong>!
                            </p>
                        </blockquote>
                    </div>
                </BoxedContent>
            </DisplayContent>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionDetailsPage);
